<template>
  <div class="item-container" @click="jumpToPage(data.id)">
    <h3>{{ data.title }}</h3>
    <span>{{ data.updatedAt | timeFormat('YYYY-MM-DD') }}</span>
    <div class="item-content">
      {{ data.subTitle }}
    </div>
  </div>
</template>

<script>

export default {
  name: "NewsItem",
  props: ['data'],
  methods: {
    jumpToPage(id) {
      this.$router.push({
        name: 'newsDetails',
        params: {
          id
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.item-container {
  display: flex;
  margin: 10px;
  flex-direction: column;
  border-bottom: 1px dashed #ebebeb;

  h3 {
    font-size: 16px;
  }

  span {
    font-size: 12px;
    color: #999;
  }

  .item-content {
    font-size: 14px;
    margin-bottom: 10px;
  }
}
</style>
